import {useEffect, useState} from "react";
import classes from "../forms/forms.module.css";
import "react-datetime/css/react-datetime.css";
import {createNews} from "../../clients/NewsApiClient";
import InputTextArea from "../fields/InputTextArea";
import sendSuccessAlert from "../../services/alertService";
import InputDate from "../fields/InputDate";

const CreateNewsForm = ({onCreate, isOpen, onClose}) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [image, setImage] = useState(null);
    const [author, setAuthor] = useState("Admin");
    const [eventDate, setEventDate] = useState(new Date());

    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                close()
                onClose();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!title || !description || !eventDate) return;

        await createNews(image, title, author, description,
            new Date(eventDate.getTime() + 3 * 60 * 60 * 1000));

        onCreate();

        onClose();
        close();
        sendSuccessAlert('Новость успешно добавлена')
    };

    if (!isOpen) return null;

    function close() {
        setTitle("");
        setDescription("");
        setImage(null);
        setAuthor("");
        setEventDate(new Date());
    }

    return (
        <div className={classes.overlay}>
            <div className={classes.modal}>
                {/* ✖ Кнопка-крестик */}
                <button className={classes.closeBtn} onClick={() => {
                    onClose();
                    close();
                }} aria-label="Закрыть">
                    ✕
                </button>

                <h2 className={classes.title}>Создание новости</h2>

                <form onSubmit={handleSubmit}>
                    <label className={classes.label}>
                        Заголовок <b className={classes.required}>*</b>
                    </label>
                    <input
                        placeholder={'Введите заголовок'}
                        type="text"
                        className={classes.input}
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />

                    <div>
                        <label className={classes.label}>Автор новости</label>
                        <input
                            placeholder={'Укажите автора'}
                            type="text"
                            value={author}
                            onChange={(e) => setAuthor(e.target.value)}
                            className={classes.input}
                        />
                    </div>

                    <label className={classes.label}>
                        Описание <text className={classes.required}>*</text>
                    </label>

                    <InputDate
                        text={'Дата мероприятия'}
                        placeholder={'Укажите дату'}
                        required={true}
                        value={eventDate}
                        onChange={(e) => setEventDate(e)}
                    />

                    <InputTextArea
                        placeholder={'Напишите суть новости'}
                        className={classes.textarea}
                        value={description}
                        onChange={(e) => setDescription(e)}
                    />


                    <label className={classes.label}>Фото</label>
                    <input
                        type="file"
                        className={classes.fileInput}
                        accept="image/*"
                        onChange={(e) => setImage(e.target.files[0])}
                    />
                    <button
                        type="submit"
                        className={classes.submit}
                        disabled={
                            title.trim().length === 0 ||
                            description.trim().length === 0 ||
                            image === null ||
                            !eventDate}
                    >
                        ✅ Добавить новость
                    </button>
                </form>
            </div>
        </div>
    );
};

export default CreateNewsForm;
